module.exports = __webpack_public_path__ + "img/safe_constructor_approved.90240071.png";